import React, { useState, useEffect } from 'react';
import EmailLink from './EmailLink'; // Import the new component
import { getContactInfo } from '../services/api'; // Import the api function

const ContactModal = ({ isOpen, onClose }) => {
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      const fetchInfo = async () => {
        setLoading(true);
        try {
          const response = await getContactInfo();
          setContactInfo(response.data);
        } catch (error) {
          console.error('Failed to fetch contact info', error);
          // Optionally set some default/error state
        } finally {
          setLoading(false);
        }
      };
      fetchInfo();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white p-8 rounded-lg shadow-2xl max-w-sm w-full">
        <h2 className="text-2xl font-bold mb-4">Contact Information</h2>
        
        {loading ? (
          <p>Loading contact details...</p>
        ) : contactInfo ? (
          <>
            <p className="mb-2">For all inquiries regarding renting or buying, please contact our main office:</p>
            <div className="bg-zinc-100 p-4 rounded-md space-y-2">
              <p><strong>Phone:</strong> <a href={`tel:${contactInfo.phone}`} className="text-emerald-600 hover:underline">{contactInfo.phone}</a></p>
              <div><strong>Email:</strong> <EmailLink email={contactInfo.email} /></div>
              <p><strong>Address:</strong> {contactInfo.address}</p>
            </div>
          </>
        ) : (
          <p>Could not load contact information.</p>
        )}

        <button 
          onClick={onClose} 
          className="mt-6 bg-gradient-to-r from-emerald-700 to-emerald-500 hover:from-emerald-600 hover:to-emerald-400 shadow-lg shadow-emerald-600/50 transform hover:-translate-y-0.5 transition-all duration-300 text-white font-bold py-2 px-4 rounded-full w-full transition duration-300"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ContactModal;
